import React from 'react';
import PropTypes from 'prop-types';

import './AllProfiles.css';

export default class AllProfilesItem extends React.Component {
    static propTypes = {
        link: PropTypes.string,
        logo: PropTypes.string,
        companyName: PropTypes.string,
        description: PropTypes.string,
    };

    render() {
        return (
            <a className="panel" href={this.props.link}>
                <div className="media u-licorice">
                    <div className="media__img">
                        <div className="image">
                            <img alt="" src={this.props.logo} />
                        </div>
                    </div>
                    <div className="media__body">
                        <h3>{this.props.companyName}</h3>
                        <p>{this.props.description}</p>
                    </div>
                </div>
            </a>
        );
    }
}
